
export const actionTypes = {
	GET_PARAMETER_FILE_LIST: 'detailedInformation/header/parameterbackup/GET_PARAMETER_FILE_LISTV2',
	GET_PARAMETER_FILE_LIST_REQUEST: 'detailedInformation/header/parameterbackup/GET_PARAMETER_FILE_LISTV2_REQUEST',
	GET_PARAMETER_FILE: 'detailedInformation/header/parameterbackup/GET_PARAMETER_FILEV2',
	GET_PARAMETER_FILE_REQUEST: 'detailedInformation/header/parameterbackup/GET_PARAMETER_FILEV2_REQUEST',
	GET_PARAMETER_BACKUP_TYPES: 'detailedInformation/header/parameterbackup/GET_PARAMETER_BACKUP_TYPES',
	GET_PARAMETER_BACKUP_TYPES_REQUEST: 'detailedInformation/header/parameterbackup/GET_PARAMETER_BACKUP_TYPES_REQUEST',
	CLEAR_PARAMETER_FILE_DATA: 'detailedInformation/header/parameterbackup/CLEAR_PARAMETER_FILEV2_DATA',
	GET_PARAMETER_BACKUP: 'gatewayManagement/GET_PARAMETER_BACKUP'
};

export const MAX_DAYS_RANGE = 90;
export const PRESELECTED_DAYS = 90;
export const ITEMS_PER_PAGE = 10;
export const DEFAULT_FILE_TYPE = 'txt';
export const FILE_TYPE_DCP = 'dcp';
export const FILE_TYPE_DCPARAMSBAK = 'dcparamsbak';
export const FILE_TYPE_DCPARAMSBAK_LABEL = 'DCPARAMSBAK';
